<template>
    <el-dialog title="道路运输证信息" :visible.sync="dialogVisible" width="400px">
        <el-form :model="form" ref="form" :rules="rules" label-width="120px" label-position="left">
            <el-form-item label="道路运输证" prop="roadTransportCertificate">
                <up-img :file.sync="form.roadTransportCertificate" width="200" height="135"></up-img>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
            <el-button size="medium" type="primary" @click="submitForm" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object,
            default: () => ({})
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            form: {
                roadTransportCertificate: ''
            },
            rules: {
                roadTransportCertificate: [
                    { required: true, message: '请上传道路运输证' }
                ],
            }
        }
    },
    watch: {
        visible(val) {
            this.dialogVisible = val;
            if (val) {
                this.initForm();
            }
        },
        dialogVisible(val) {
            this.$emit('update:visible', val);
        }
    },
    methods: {
        initForm() {
            this.form = {
                roadTransportCertificate: this.info.roadTransportCertificate || '',
            };
        },
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$emit('submit', this.form);
                }
            });
        }
    }
}
</script>